import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export const StatusOption = ({ value, label, selected, onChange, readOnly }) => (
  <button
    type="button"
    onClick={() => !readOnly && onChange(value)}
    disabled={readOnly}
    className={`px-2 py-1 text-xs rounded transition-all whitespace-nowrap ${
      selected
        ? value === 'abnormal' || value === 'absent'
          ? 'bg-[#C06144] text-white'
          : value === 'unable_to_evaluate'
            ? 'bg-[#8B6F47] text-white'
            : 'bg-[#4B6651] text-white'
        : 'bg-[#F8F7F4] text-[#5C5F5C] hover:bg-[#E5E4E0]'
    } ${readOnly ? 'cursor-default opacity-80' : ''}`}
  >
    {label}
  </button>
);

export const ReflexSelect = ({ value, onChange, testId, readOnly }) => (
  <Select value={value} onValueChange={onChange} disabled={readOnly}>
    <SelectTrigger className="w-full bg-[#F8F7F4] border-[#E5E4E0]" data-testid={testId}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="0">0 (Absent)</SelectItem>
      <SelectItem value="+1">+1 (Hyporeflexia)</SelectItem>
      <SelectItem value="+2">+2 (Normal)</SelectItem>
      <SelectItem value="+3">+3 (Hyperreflexia)</SelectItem>
      <SelectItem value="+4">+4 (Clonus)</SelectItem>
      <SelectItem value="unable_to_evaluate">Unable to Evaluate</SelectItem>
    </SelectContent>
  </Select>
);

export const SideSelector = ({ field, show, formData, handleChange, readOnly }) => {
  if (!show) return null;
  const sideField = `${field}_side`;
  const current = formData[sideField] || '';
  return (
    <div className="flex gap-1 mt-1.5" data-testid={`side-${field}`}>
      {[
        { value: 'left', label: 'L' },
        { value: 'right', label: 'R' },
        { value: 'both', label: 'Both' },
      ].map(({ value, label }) => (
        <button
          key={value}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && handleChange(sideField, current === value ? '' : value)}
          className={`px-2 py-0.5 text-xs rounded transition-all ${
            current === value
              ? 'bg-[#C06144] text-white'
              : 'bg-white border border-[#E5E4E0] text-[#5C5F5C] hover:bg-[#F8F7F4]'
          } ${readOnly ? 'cursor-default opacity-80' : ''}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
